export const postFiltersPreferencesAdapter = ({
  idsServicios,
  idsProveedores,
  idsContratos,
  unidadesNegocioIds,
  operacionesIds,
  ...filters
}) => ({
  asinacionEvento: filters.asignacionEventoEnum,
  numeroSolicitud: null,
  numeroSolicitudServicio: filters?.numeroSolicitud || [],
  servicios: idsServicios?.length ? idsServicios : [],
  proveedores: idsProveedores?.length ? idsProveedores : [],
  contratos: idsContratos?.length ? idsContratos : [],
  fechaHasta: filters.fechaHasta || null,
  fechaDesde: filters.fechaDesde || null,
  tipoUbicacionEnum: filters.tipoUbicacionEnum || null,
  ubicacion: filters.ubicacion || null,
  eventos: filters.idEvento || [],
  equipoDeTorre: filters.equipo || [],
  usuarioCreador: filters.idUsuarioCreador || null,
  prioridad: filters.idPrioridad
    ? { id: filters.idPrioridad.id, nombre: filters.idPrioridad.nombre }
    : null,
  unidadesNegocio: unidadesNegocioIds?.length
    ? unidadesNegocioIds.map((unidad) => ({
        id: unidad.id,
        nombre: unidad.nombre
      }))
    : [],
  operaciones: operacionesIds?.length
    ? operacionesIds.map((operacion) => ({ id: operacion.id, nombre: operacion.nombre }))
    : [],
  estadosEnums: filters?.estadosEnums?.length
    ? filters.estadosEnums.map((status) => ({ id: status.id, nombre: status.nombre }))
    : []
});

export const postFilterPreferenceApproverAdapter = ({
  idsServicios,
  idsProveedores,
  idsContratos,
  operacionesIds,
  ...filters
}) => ({
  idUsuario: filters.idUsuario || null,
  numerosContrato: filters.numerosContrato || null,
  numerosSolicitudes: filters.numeroSolicitud?.length
    ? filters.numeroSolicitud.map((req) => ({
        id: req.id,
        nombre: req.nombre,
        tipoAsignacion: req.tipoAsignacion
      }))
    : [],
  posicionesLineas: filters.posicionesLineas?.length
    ? filters.posicionesLineas.map((posicionLinea) => String(posicionLinea?.value))
    : [],
  equipos: filters.equipo.length
    ? filters.equipo.map((equip) => ({
        id: equip.id,
        nombre: equip.nombre
      }))
    : [],
  servicios: idsServicios.length
    ? idsServicios.map((servicio) => ({
        id: servicio.id,
        nombre: servicio.nombre
      }))
    : [],
  proveedores: idsProveedores.length
    ? idsProveedores.map((proveedor) => ({
        id: proveedor.id,
        nombre: proveedor.nombre
      }))
    : [],
  tipoEvento: filters.evento.length
    ? filters.evento.map((evento) => ({
        id: evento.id,
        nombre: evento.nombre
      }))
    : [],
  tipoUbicacionEnum: filters.tipoUbicacionEnum
    ? {
        id: filters.tipoUbicacionEnum.id,
        nombre: filters.tipoUbicacionEnum.nombre
      }
    : null,
  ubicaciones: filters?.ubicacion
    ? filters.ubicacion.map((ubicacion) => ({
        id: ubicacion.id,
        nombre: ubicacion.nombre
      }))
    : [],
  unidadesNegocio: filters.unidadesNegocioIds?.length
    ? filters.unidadesNegocioIds.map((unidad) => ({
        id: unidad.id,
        nombre: unidad.nombre
      }))
    : [],
  estadosSolicitud: filters.estadosSolicitud?.length
    ? filters.estadosSolicitud.map((status) => ({
        id: status.id,
        nombre: status.nombre
      }))
    : [],
  operaciones: operacionesIds?.length
    ? operacionesIds.map((operacion) => ({ id: operacion.id, nombre: operacion.nombre }))
    : [],
  contratos: idsContratos?.length
    ? idsContratos.map((contrato) => ({ id: contrato.id, nombre: contrato.nombre }))
    : []
});

export const postFilterPreferenceDetailSDSAdapter = (filters) => {
  const { posicionesLineas } = filters;

  return {
    posicionesLineas: posicionesLineas?.map((linePos) => ({
      posicion: linePos?.posicion,
      posicionId: linePos?.posicionId,
      linea: linePos?.linea,
      lineaId: linePos?.lineaId,
      label: linePos?.label
    }))
  };
};

export const postFilterPreferencesDetailMSDSAdapter = (filters) => {
  const fil = {
    equiposIds: filters?.towerEquipments?.map((equip) => equip.id) || [],
    eventosIds: filters?.events.map((evnt) => evnt.id) || [],
    tipoUbicacionesIds: filters?.ubicationType ? [filters?.ubicationType?.id] : [],
    ubicacionesIds: filters?.ubications ? [filters?.ubications?.id] : [],
    posicionesLineas:
      filters?.posicionesLineas?.map((pos) => ({
        posicion: pos?.posicion,
        posicionId: pos?.posicionId,
        linea: pos?.linea,
        lineaId: pos?.lineaId,
        label: pos?.label
      })) || []
  };

  return fil;
};
